import { render, staticRenderFns } from "./FiveStepsStep.vue?vue&type=template&id=f6fe1160&scoped=true&"
import script from "./FiveStepsStep.vue?vue&type=script&lang=ts&"
export * from "./FiveStepsStep.vue?vue&type=script&lang=ts&"
import style0 from "./FiveStepsStep.vue?vue&type=style&index=0&id=f6fe1160&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6fe1160",
  null
  
)

export default component.exports